module.exports = __webpack_public_path__ + "static/media/calendar.a7645965.svg";